import React, { useState, useEffect } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { Employee } from '../TitleList';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { createEmployeeEntry } from '../../Store/PHPSlice/Employee';
import Dropdown from '../FieldsComponents/Dropdown';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const EmployeeEntry = (props) => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    // console.log(userdata);
    const [formData, setFormData] = useState({
        empName: '',
        ph: '',
        emailId: '',
        departId: '',
        payType: '3',
        amt: '',
        empType: '',
        punchId: 0,
        userId: userdata?.userId
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const department = useSelector((state) => state.DepartmentData.department || { data: [] });
    useEffect(() => {
        dispatch(fetchDepartmentData());
    }, [dispatch]);
    // console.log(department.data);
    if (!department) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'amt') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };


    const validate = () => {
        const newErrors = {};
        if (!formData.empName) newErrors.empName = 'Employee Name is required';
        if (!formData.departId) newErrors.departId = 'Department is required';
        if (!formData.payType) newErrors.payType = 'Payment Type is required';
        if (!formData.empType) newErrors.empType = 'Employee Type is required';
        if (!formData.ph) {
            newErrors.ph = 'Contact is required';
        } else if (!/^\d{10}$/.test(formData.ph)) {
            newErrors.ph = 'Contact must be a 10-digit number';
        }


        return newErrors;
    };

    function postObj(formData) {
        const data = {
            empName: formData.empName === '' ? 0 : formData.empName,
            ph: formData.ph === '' ? 0 : formData.ph,
            emailId: formData.emailId === '' ? 0 : formData.emailId,
            departId: formData.departId === '' ? 0 : formData.departId,
            payType: formData.payType === '' ? 0 : formData.payType,
            amt: formData.amt === '' ? 0 : formData.amt,
            empType: formData.empType === '' ? 0 : formData.empType,
            punchId: formData.punchId === '' ? 0 : formData.punchId,
            userId: formData.userId === '' ? 0 : formData.userId,
        };
        return data;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const finaldata = postObj(formData);
        dispatch(createEmployeeEntry(finaldata))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Employee Added");
                alert("Employee Added");
                { props?.data === 1 ? window.close() : window.location.reload(); }
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };


    const PaymentType = [
        { label: 'Weekly', value: 1 },
        { label: 'Monthly', value: 2 },
        { label: 'On-Work', value: 3 },
    ];

    const empType = [
        { label: 'In', value: 'In' },
        { label: 'Out', value: 'Out' }
    ];
    const handlenavigate = () => {
        window.open(`/new-department`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const dropdownlistfirst = [
        {
            label: 'Department',
            id: 'departId',
            options: department?.data || [],
            value: formData.departId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'departId', value: newValue ? newValue.ID : '' } }, 'departId'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: handlenavigate
        }

    ];


    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    return (
        <>
            {props?.data === 1 ? null : <Titlebar data={Employee} />}
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Employee Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Employee Name', name: 'empName' },
                                    { label: 'Contact', name: 'ph' },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Amount', name: 'amt' },
                                    { label: 'Punching Id', name: 'punchId' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="departId">Department :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.departId}>
                                                <Select
                                                    labelId="departId"
                                                    id="departId"
                                                    name="departId"
                                                    value={formData.departId}
                                                    onChange={(e) => handleDropdownChange(e, 'departId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        department?.data?.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.departNm}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.departId && <FormHelperText style={errorStyles}>{errors.departId}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            errorshow={errors}
                                            handleAddNew={drop.handleAddNew}
                                            handleDropdownOpen={handleDropdownOpen}  // Pass `valueFinder` function here
                                            handleDropdownClose={handleDropdownClose}
                                        />
                                    ))
                                }

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="payType">Payment Type :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.payType}>
                                                <Select
                                                    labelId="payType"
                                                    id="payType"
                                                    name="payType"
                                                    value={formData.payType}
                                                    onChange={(e) => handleDropdownChange(e, 'payType')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        PaymentType.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.payType && <FormHelperText style={errorStyles}>{errors.payType}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="empType">Employee Type :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="empType"
                                                    id="empType"
                                                    name="empType"
                                                    value={formData.empType}
                                                    onChange={(e) => handleDropdownChange(e, 'empType')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        empType.map((item, index) => (
                                                            <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {errors.empType && <FormHelperText style={errorStyles}>{errors.empType}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default EmployeeEntry;